import loadable from 'react-loadable';

export function lazy<T>(loader, options = {}) {
  const loadableOptions: any = {
    loader,
    loading: () => null,
  };

  return loadable(loadableOptions);
}